import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { authService } from '@/features/authentication/services/auth.service';
import { APP_ROUTES } from '@/shared/constants/routes.constants';

export interface PrivateRouteProps {
  children: React.ReactNode;
}

/**
 * PrivateRoute guard component
 * Protects routes that require authentication
 * Redirects to login if user is not authenticated
 */
export const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const location = useLocation();
  const isAuthenticated = authService.isAuthenticated();

  if (!isAuthenticated) {
    // Redirect to login, preserving the attempted URL
    return <Navigate to={APP_ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
